import { uploads } from 'js/src/data/uploads/uploads-reducers';

/* MODULE EXPORTS */
export * from 'js/src/data/uploads/uploads-actions';
export * from 'js/src/data/uploads/uploads-selectors';
export * from 'js/src/data/uploads/uploads-types';
export * from 'js/src/data/uploads/uploads-operations';

export default uploads;
